<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    icon="fa-money-check-alt"
    :submitting="submitting"
    :submitTitle="submitTitle"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="2">
      <ContentTitle>Subscription</ContentTitle>

      <div v-if="!isCreateMode">
        <FormRow label="Active">
          <FormCheckbox v-model="subscription.isActive" />
        </FormRow>
        <FormRow label="Auto Renew">
          <FormCheckbox v-model="subscription.isAutoRenewEnabled" />
        </FormRow>
        <FormRow label="Expiry Date">
          <FormDate v-model="subscription.expiryDate" />
        </FormRow>

        <FormHorizontalRule />

        <ContentTitle>Subscription Items</ContentTitle>
        <StaticDataTable class="static-table-list">
          <template v-slot:header>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Quantity</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="subItem in subscription.subscriptionItems" :key="subItem.id">
              <td class="font-weight-bold">
                {{subItem.name}}
              </td>
              <td>
                {{subItem.description}}
              </td>
              <td>
                {{subItem.quantity}}
              </td>
            </tr>
          </template>
        </StaticDataTable>
      </div>

      <div v-if="isCreateMode">
        <FormRow label="Auto Renew">
          <FormCheckbox v-model="subscription.isAutoRenewEnabled" />
        </FormRow>
        <FormRow label="Expiry Date">
          <FormDate v-model="subscription.expiryDate" />
        </FormRow>
        <FormRow label="Product Link">
          <FormSelect :options="subscriptionProductLookup" v-model="subscription.billingProductId" />
        </FormRow>
        <FormRow label="Product Quantity">
          <FormInputText type="number" v-model="subscription.quantity" />
        </FormRow>


      </div>
      
      
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'DeveloperEditSubDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    subscriptionId: Number,
    accountId: Number,
    isCreateMode: Boolean
  },
  data() {
    return {
      subscription: { },
      form: {},
      billingProductList: [],
      submitting: false
    }
  },
  mounted() {
    this.requestData()
  },
  computed: {
    title() {
      return this.isCreateMode ? 'Create Subscription' : 'Edit Subscription'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    },
    subscriptionProductLookup() {
      return _.concat(
        [{ value: 0, name: 'None' }]
      , this.billingProductList
      .filter(billingProduct => {
        if(!billingProduct.isActive)
          return false

        // Only use products that have subscription pricing (eg, not one_time)
        if(_.isArray(billingProduct.priceInfoList) && billingProduct.priceInfoList.length > 0) {
          if(billingProduct.priceInfoList.every(priceInfo => priceInfo.interval == 'one_time'))
            return false
        } else {
          // No pricing info defined. Ignore it
          return false
        }

        return true
      })
      .map(billingProduct => {
        return {
          value: billingProduct.id,
          name: `${billingProduct.name} - ${billingProduct.description}`
        }
      }))
    }
  },
  methods: {
    show(subscription) {
      // Reset form
      this.subscription = { }
      this.form = {}
      this.submitting = false

      if(subscription)
        this.subscription = _.cloneDeep(subscription)
      else {
        this.subscription = {
          isAutoRenewEnabled: true,
          expiryDate: moment().local().add(3, 'months').toISOString(),
          quantity: 1,
          billingProductId: 0
        }
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      if(!this.isCreateMode) {
        var updateData = {
          isActive: this.subscription.isActive,
          isAutoRenewEnabled: this.subscription.isAutoRenewEnabled,
          expiryDate: this.subscription.expiryDate
        }

        this.$apiService.developerService.developerUpdateSubscription(this.accountId, this.subscription.id, updateData)
          .then(() => {
            this.submitting = false
            this.modalClosed(true)
            this.hide()
          })
          .catch(err => {
            this.submitting = false
            this.$data.form = this.processFormResponse(err)
          })
      } else {
        var createData = {
          isAutoRenewEnabled: this.subscription.isAutoRenewEnabled,
          expiryDate: this.subscription.expiryDate,
          quantity: this.subscription.quantity,
          billingProductId: this.subscription.billingProductId
        }

        this.$apiService.developerService.developerCreateSubscription(this.accountId, createData)
          .then(() => {
            this.submitting = false
            this.modalClosed(true)
            this.hide()
          })
          .catch(err => {
            this.submitting = false
            this.$data.form = this.processFormResponse(err)
          })
      }
    },
    requestData() {
      this.$apiService.developerService.developerGetBillingProducts()
      .then(response => {
        this.billingProductList = response.data
      })
    }
  }
}
</script>